import './scss/shiptimize.scss';
import './css/leaflet.css';

import Woocommerce        from './js/shiptimize-woo-commerce.js';
import ShiptimizeCheckout from './js/shiptimize-checkout.js';

/**
 * Shiptimize — entry point.
 *
 * Creates a ShiptimizeCheckout instance and kicks off initialisation.
 * Depends on jQuery and the `woocommerce_params` global provided by WC.
 */
class Shiptimize {
  constructor(ajaxUrl) {
    this._ajaxUrl = ajaxUrl;
    this._wc      = new Woocommerce(ajaxUrl);

    if (!this._wc.isCheckout()) return;

    this.checkout = new ShiptimizeCheckout({
      ajaxUrl:            ajaxUrl,
      nonce:              typeof shiptimize_vars !== 'undefined' ? shiptimize_vars.nonce : '',
      host:               'https://shiptimize.me',
      gmapsKey:           typeof shiptimize_maps_key !== 'undefined' ? shiptimize_maps_key : '',
      mapParentContainer: 'body',
      labels:             {},
    });

    this.checkout.init();

    // Pre-load map resources after a short delay so the checkout renders first
    setTimeout(() => this._preloadMapResources(), 2000);
  }

  /**
   * Build the map HTML in the background so it is ready when the customer
   * clicks "Choose Pickup Location" for the first time.
   */
  _preloadMapResources() {
    if (this.checkout.mapinterface && jQuery('#sw').length === 0) {
      this.checkout.addMapHtml();
    }
  }
}

jQuery(() => {
  if (typeof woocommerce_params !== 'undefined') {
    window.shiptimize = new Shiptimize(woocommerce_params.ajax_url);
  }
});
